import { Link } from 'react-router-dom'

/** Coral call-to-action band used at the end of content pages. */
function CtaBand({ title = 'Ready to order?', body, cta = 'Order a cake', to = '/cake-builder' }) {
  return (
    <section className="bg-coral-500 text-white">
      <div className="container mx-auto px-4 py-8 md:py-16 max-w-6xl flex flex-col items-start md:items-center md:text-center gap-3.5 md:gap-5">
        <h2 className="text-[26px] md:text-4xl text-white">{title}</h2>
        {body && <p className="text-[15px] md:text-lg text-white/90 leading-relaxed max-w-xl">{body}</p>}
        <Link
          to={to}
          className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-full bg-white text-coral-600 font-semibold text-[15px] hover:bg-cream transition-colors active:scale-[0.98]"
        >
          {cta}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round" className="w-[18px] h-[18px]" aria-hidden="true">
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </Link>
      </div>
    </section>
  )
}

export default CtaBand
